/* eslint disable */
<template>
  <div class="container-fluid no-padding">
    <div class="row bg-primary-dark border-bottom">
      <div class="col-md-4 mb-2 mt-2">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">Personel</span>
          </div>
          <select class="custom-select" :disabled="!isCardVisible()" @change="changePersonel()" v-model="queryModel.personelId">
            <option selected value="0">Personel Seçiniz...</option>
            <option value="0082C936">Ayten Ayhan</option>
            <option value="0023711C">Ebru Karataş</option>
            <option value="00279BBD">Erdoğan Bulut</option>
            <option value="00621551">Gülizar Yıldırım</option>
            <option value="002B7DC9">Hasan Cemre Ok</option>
            <option value="007F6EAB">Murat Aslan</option>
            <option value="0093CF0E">Naime Eşki</option>
            <option value="00281126">Şaban Durdu</option>
          </select>
        </div>
      </div>
      <div class="col-md-4 mb-2 mt-2 align-middle">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">Dönem</span>
          </div>
          <select class="custom-select" @change="getPersonelEntranceReport()" v-model="queryModel.selection.month">
            <option v-for="(month, index) in queryModel.date.months" 
              :value="month.value" v-bind:key="'month-' + index">{{month.text}}</option>
          </select>
          <select class="custom-select" @change="getPersonelEntranceReport()" v-model="queryModel.selection.year">
            <option v-for="(year, index) in queryModel.date.years" 
              :value="year" v-bind:key="'year-' + index">{{year}}</option>
          </select>
          <div class="input-group-append">
            <span class="input-group-text" id="basic-addon1">Yıl</span>
            <!--<button class="btn btn-outline-primary dropdown-toggle" style="width: 140px;" 
              type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{queryModel.selection.year}}</button>
            <div class="dropdown-menu">
              <a class="dropdown-item" href="#" @click="setSelectionYear(year)"
                v-for="(year, index) in queryModel.date.years" 
                :value="year" v-bind:key="'year-' + index">{{year}}</a>
            </div>-->
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-2 mt-2 align-middle">
        <button class="btn btn-more-radius btn-primary float-right text-white" @click="copyTable()">
          <i class="far fa-copy mr-2 text-white"></i>Tabloyu Kopyala
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <v-wait for='entrance-loading'>
          <template slot="waiting">
            <div class="vue-wait-class">
              <img src="static/loading.svg" />
              <p>Giriş kayıtları yükleniyor...</p>
            </div>
          </template>
          <table class="table ">
            <table class="table table-bordered table-hover">
              <thead class="thead-light">
                <tr>
                  <th class="align-middle" style="width: 15%;" scope="col">PERSONEL</th>
                  <th class="align-middle" style="width: 20%;">TARİH</th>
                  <th class="align-middle" style="width: 10%;">GİRİŞ ZAMANI</th>
                  <th class="align-middle" style="width: 10%;">ÇIKIŞ ZAMANI</th>
                  <th class="align-middle" style="width: auto;">GÜNLÜK GECİKME</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="align-middle bg-highlighted" style="width: 15%;" scope="col">{{report[0].DRIVER_NAME}}</td>
                  <td class="align-middle justify-content-between lh-condensed  bg-highlighted" style="width: 20%;">
                    <p class="my-0 font-semi-bold">{{totalDays}} gün</p>
                    <small class="text-primary">Değerlendirilen gün sayısı</small>
                  </td>
                  <td class="align-middle justify-content-between lh-condensed bg-highlighted" style="width: 10%;">
                    <p class="my-0 font-semi-bold">{{totalLate}} dk.</p>
                    <small class="text-danger">Toplam geç kalınan süre</small>
                  </td>
                  <td class="align-middle justify-content-between lh-condensed bg-highlighted" style="width: 10%;">
                    <p class="my-0 font-semi-bold">{{totalEarly}} dk.</p>
                    <small class="text-danger">Toplam erken çıkılan süre</small>
                  </td>
                  <td class="align-middle justify-content-between lh-condensed bg-highlighted" style="width: auto;">
                    <p class="my-0 font-semi-bold">{{combinedMin}} dk.</p>
                    <small class="text-danger">Mesai saatinden eksilen toplam süre</small>
                  </td>
                </tr>
                <tr v-for="(dataRow, index) in report" v-bind:key="'datarow-' + index">
                  <td class="align-middle" style="width: 15%;">{{dataRow.DRIVER_NAME}}</td>
                  <td class="align-middle justify-content-between lh-condensed" 
                    style="width: 20%;">
                    <p class="my-0 font-semi-bold">{{dataRow.OnDate_FORMATTED}}</p>
                    <small class="font-semi-bold">{{queryModel.selection.year}}</small>
                  </td>
                  <td class="align-middle justify-content-between lh-condensed" 
                    style="width: 20%;">
                    <p class="my-0 font-semi-bold">{{dataRow.ENTRANCE_TIME_FORMATTED}}</p>
                    <small class="font-semi-bold" :class="parseEntranceAsClass(dataRow.LATE_TODAY)">{{parseEntranceAsText(dataRow.LATE_TODAY)}}</small>
                  </td>
                  <td class="align-middle justify-content-between lh-condensed" 
                    style="width: 20%;">
                    <p class="my-0 font-semi-bold">{{dataRow.LEFT_TIME_FORMATTED}}</p>
                    <small class="font-semi-bold" :class="parseLeftAsClass(dataRow.EARLY_LEFT)">{{parseLeftAsText(dataRow.EARLY_LEFT)}}</small>
                  </td>
                  <td class="align-middle justify-content-between lh-condensed">
                    <p class="my-0 font-semi-bold">{{dataRow.LATE_TOTAL}} dk.</p>
                    <small class="text-danger">Günlük mesaiden eksilen süre</small>
                  </td>
                </tr>
              </tbody>
            </table>
          </table>
        </v-wait>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import moment from 'moment'

export default {
  name: 'ProfilePage',
  computed : {
    getPersonelId: function() { return this.$store.getters.getPersonelId; },
    getSessionId: function() { return this.$store.getters.getSessionId; },
  },
  data () {
    return {
      report: null,
      combinedMin: 0,
      totalLate: 0,
      totalEarly: 0,
      totalDays: 0,
      queryModel: {
        personelId: '0',
        date: {
          nowYear: '2020',
          nowMonth: '1',
          months:[],
          years: []
        },
        selection: {
          year: 0,
          month: 0,
        }
      },
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 2500
      }
    }
  },
  methods: {
    isCardVisible() { return this.getPersonelId == 3 || this.getPersonelId == 24},
    changePersonel() {
      this.$router.push({ path: "/personel/" + this.queryModel.personelId })
      this.getPersonelEntranceReport()
    },
    async getPersonelEntranceReport() {
      if(this.$route.params.id === undefined)
        return

      this.totalLate = 0;
      this.totalEarly = 0;
      this.combinedMin = 0;
      this.report = []
      this.queryModel.personelId = this.$route.params.id
      this.$wait.start('entrance-loading')

      await axios.post('/api/session/entrance-monthly' + 
      '?SessionId='+ this.getSessionId + 
      '&month=' + (parseInt(this.queryModel.selection.month) + 1) + 
      '&year=' + this.queryModel.selection.year +
      '&identityCode=' + this.queryModel.personelId)
      .then(response => {
        if(response.data.length == 0) {
          this.$toasted.error('Seçtiğiniz kriterlere uygun rapor bulunamadı.', this.toastOptions)
          return;
        }

        this.report = response.data;
        let entranceWorking = response.data;
        
        let nextEntrance = null;
        for(let z = 0; z < this.report.length; z++) {
          nextEntrance = this.report[z].OnDate;

          let dates = entranceWorking.filter(m => m.OnDate == nextEntrance)
          if(dates.length >= 2) {
            entranceWorking[z].LEFT_TIME_FORMATTED = dates[dates.length - 1].ENTRANCE_TIME_FORMATTED
              
            let iOutrance = moment(entranceWorking[z].LEFT_TIME_FORMATTED)
            entranceWorking[z].EARLY_LEFT = iOutrance.diff(normalOutrance, 'minutes')
              
            entranceWorking[z].LATE_TOTAL = 
              (parseInt(entranceWorking[z].LATE_TODAY) < 0 ? 0 : parseInt(entranceWorking[z].LATE_TODAY))
              + (entranceWorking[z].EARLY_LEFT > 0 ? 0 : Math.abs(parseInt(entranceWorking[z].EARLY_LEFT)))

            entranceWorking.splice(z + 1, dates.length - 1);

          } else if (dates.length == 1) {
            let oneHour = parseInt(entranceWorking[z].ENTRANCE_TIME_FORMATTED.substring(0, 2))
            if(oneHour >= 13) {
              entranceWorking[z].LEFT_TIME_FORMATTED = entranceWorking[z].ENTRANCE_TIME_FORMATTED
              entranceWorking[z].ENTRANCE_TIME_FORMATTED = "00:00"
            } else {
              entranceWorking[z].LEFT_TIME_FORMATTED = "00:00"
            }
          }
        }

        let onDate = null;
        let normalEntrance = null;
        let normalOutrance = null;

        for(let i = 0; i < entranceWorking.length; i++) {

          onDate = entranceWorking[i].OnDate;
          normalEntrance = moment(onDate).add(9, 'hour')
          normalOutrance = moment(onDate).add(18, 'hour')

          let hour, min;
          hour = parseInt(entranceWorking[i].ENTRANCE_TIME_FORMATTED.substring(0, 2));
          min = parseInt(entranceWorking[i].ENTRANCE_TIME_FORMATTED.substring(3, 5));

          let iEntrance = null;
          if(hour != 0) {
            iEntrance = moment(onDate).add({hours: hour, minutes: min});
            entranceWorking[i].LATE_TODAY = iEntrance.diff(normalEntrance, 'minutes')
            iEntrance = null;
          } else {
            entranceWorking[i].LATE_TODAY = 0
          }
          
          hour = parseInt(entranceWorking[i].LEFT_TIME_FORMATTED.substring(0, 2));
          min = parseInt(entranceWorking[i].LEFT_TIME_FORMATTED.substring(3, 5));
          
          let iOutrance = null;
          if(hour != 0) {
            iOutrance = moment(onDate).add({hours: hour, minutes: min});
            entranceWorking[i].EARLY_LEFT = iOutrance.diff(normalOutrance, 'minutes')
            iOutrance = null;
          } else {
            entranceWorking[i].EARLY_LEFT = 0
          }

          entranceWorking[i].LATE_TOTAL = 
            (parseInt(entranceWorking[i].LATE_TODAY) < 0 ? 0 : parseInt(entranceWorking[i].LATE_TODAY))
            + (entranceWorking[i].EARLY_LEFT > 0 ? 0 : Math.abs(parseInt(entranceWorking[i].EARLY_LEFT)))


          iOutrance = null;
          this.totalLate += Math.abs(parseInt(entranceWorking[i].LATE_TODAY) < 0 ? 0 : parseInt(entranceWorking[i].LATE_TODAY))
          this.totalEarly += Math.abs(parseInt(entranceWorking[i].EARLY_LEFT) > 0 ? 0 : parseInt(entranceWorking[i].EARLY_LEFT))
        }

        normalEntrance = null;
        normalOutrance = null;
        this.report = entranceWorking;
        this.totalDays = entranceWorking.length
        this.combinedMin = this.totalLate + this.totalEarly;

        this.$wait.end('entrance-loading')
      }).catch(err => {
        this.report = []
      })
    },
    prepareView() {
      this.queryModel.date.nowYear = moment().year()
      this.queryModel.date.nowMonth = moment().month()
      this.queryModel.selection.month = this.queryModel.date.nowMonth
      this.queryModel.selection.year = this.queryModel.date.nowYear

      for(let i = this.queryModel.date.nowYear; i >= 2018; i--)
        this.queryModel.date.years.push(i)
      
      for(let x = 11; x >= 0; x--)
        this.queryModel.date.months.push({'text': moment({month: x}).format('MMMM'), 'value': x})

      console.log(this.queryModel)
    },
    setSelectionYear(year) {
      this.queryModel.selection.year = year
    },
    parseEntranceAsClass(entrance) {
      if(entrance <= 0)
        return 'text-success'
      else
        return 'text-danger'
    },
    parseEntranceAsText(entrance) {
      if(entrance <= 0)
        return 'Zamanında'
      else
        return entrance + " dk. geç"
    },
    parseLeftAsClass(left) {
      if(left < 0)
        return 'text-danger'
      else
        return 'text-success'
    },
    parseLeftAsText(left) {
      if(left < 0)
        return Math.abs(left) + " dk. erken"
      else
        return "Zamanında"
    }
  },
  created() {
    moment.locale('tr')
    this.prepareView()
  },
  mounted() {
    this.getPersonelEntranceReport()
  },
  destroy() { },
}
</script>

<style scoped>
  th, .dropdown-item {
    font-size: .875rem;
  }
  .font-semi-bold {
    font-weight: 500;
  }
  .bg-highlighted {
    border-bottom: 3px solid #D0D0D0;
    background: #f0f0f0 !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/ProfilePage.vue